<script>
import { NodeMixin } from '@/helpers/node-mixin';

export default {
  name: 'ConditionBranchNode',
  template: '#condition-branch-node-template',
  mixins: [NodeMixin],
  emits: ['click'],
};
</script>
